import type { YearTheme } from '../../types';
import { purple, orange, blue, green } from '../../colorRamps';

// 2025 theme — the original brand palette. Matches the default @theme block in
// index.css so the 2025 event renders identically to before the multi-year refactor.
export const theme: YearTheme = {
  primary: purple,
  accent: orange,
  secondary: blue,
  success: green,
};
